module.exports = __webpack_public_path__ + "img/STREAMER_VETRUNGTHUONG.c43b4b19.jpg";